{
  "name": "@mu-private-area/source",
  "version": "0.1.1",
  "license": "MIT",
  "scripts": {
    "serve:ssr": "node dist/apps/mu-private-area/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~19.1.0",
    "@angular/common": "~19.1.0",
    "@angular/compiler": "~19.1.0",
    "@angular/core": "~19.1.0",
    "@angular/forms": "~19.1.0",
    "@angular/google-maps": "^19.2.4",
    "@angular/material": "^19.2.9",
    "@angular/platform-browser": "~19.1.0",
    "@angular/platform-browser-dynamic": "~19.1.0",
    "@angular/platform-server": "~19.1.0",
    "@angular/router": "~19.1.0",
    "@angular/ssr": "~19.1.0",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@splidejs/splide": "^4.1.4",
    "@types/googlemaps": "^3.43.3",
    "angular-flatpickr": "^3.6.6",
    "angular-svg-icon": "^19.1.1",
    "dropzone": "^5.9.3",
    "express": "^4.21.2",
    "flatpickr": "^4.6.13",
    "flyonui": "^1.3.0",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "rxjs": "~7.8.0",
    "sweetalert2": "^11.17.2",
    "tailwind-merge": "^3.0.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~19.1.0",
    "@angular-devkit/core": "~19.1.0",
    "@angular-devkit/schematics": "~19.1.0",
    "@angular/cli": "~19.1.0",
    "@angular/compiler-cli": "~19.1.0",
    "@angular/language-service": "~19.1.0",
    "@eslint/js": "^9.8.0",
    "@nx/angular": "20.4.6",
    "@nx/eslint": "20.4.6",
    "@nx/eslint-plugin": "20.4.6",
    "@nx/jest": "20.4.6",
    "@nx/js": "20.4.6",
    "@nx/web": "20.4.6",
    "@nx/workspace": "20.4.6",
    "@schematics/angular": "~19.1.0",
    "@swc-node/register": "~1.9.1",
    "@swc/core": "~1.5.7",
    "@swc/helpers": "~0.5.11",
    "@types/dropzone": "^5.7.9",
    "@types/express": "^4.17.21",
    "@types/jest": "^29.5.12",
    "@types/node": "18.16.9",
    "@typescript-eslint/utils": "^8.19.0",
    "angular-eslint": "^19.0.2",
    "autoprefixer": "^10.4.0",
    "eslint": "^9.8.0",
    "eslint-config-prettier": "^9.0.0",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-preset-angular": "~14.4.0",
    "nx": "20.4.6",
    "postcss": "^8.4.5",
    "postcss-cli": "^11.0.0",
    "prettier": "^2.6.2",
    "tailwindcss": "^3.0.2",
    "ts-jest": "^29.1.0",
    "ts-node": "10.9.1",
    "tslib": "^2.3.0",
    "typescript": "~5.7.2",
    "typescript-eslint": "^8.19.0"
  }
}
